import Header from "components/Headers/Header";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { get } from "utils/api";
import { GetColorName } from "hex-color-to-color-name";
import img_cpclean from "assets/images/cpclean.png";
import img_cpdelux from "assets/images/cpdelux.png";
import img_checkicon from "assets/images/checkicon.svg";
import img_clock from "assets/images/clock.svg";
import img_Date from "assets/images/Date.svg";
import img_invoice from "assets/images/invoice.svg";
import HouseDummyImg from "assets/images/houseDummy.webp";


const OrderHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentService } = location.state || {};
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");
  const role = queryParams.get("role");
  const orderId = queryParams.get("orderId");
  const [isLoading, setIsLoading] = useState(false);
  const [orderHistory, setOrderHistory] = useState([]);
  const [openCollapseId, setOpenCollapseId] = useState(null);

  const handleToggleCollapse = (orderId) => {
    setOpenCollapseId(openCollapseId === orderId ? null : orderId);
  };

  const fetchApi = () => {
    setIsLoading(true);
    get(`api/admin/get/orderHistory`, {
      userId,
      role,
      currentService,
      orderId: orderId ?? parseInt(orderId) ?? null,
    })
      .then((res) => {
        setOrderHistory(res?.data?.mainCart);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchApi();
  }, [userId, role]);

  const isPaid = (order) => {
    return order.payment_status === "succeeded";
  };
  const handleClickOnName = (role, id) => {
    navigate(`/user/${role}/${id}`);
  };
     const handleError = (e) => {
      e.target.src = HouseDummyImg; // Fallback to the dummy image on error
    };
  return (
    <>
      <Header title={"Order History "} />
      {isLoading ? (
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      ) : orderHistory ? (
        <div className="cart-sec">
          <div className="container-fluid my-container">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="accordion" id="accordionExample">
                  <div>
                    <button
                      className="navbar-toggler"
                      type="button"
                      onClick={() => {
                        window.history.back();
                      }}
                    >
                      Go Back{" "}
                    </button>
                  </div>
                  {orderHistory.map((order, index) => {
                    return (
                      <div key={index} className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            key={order.order_id}
                            data-bs-toggle="collapse"
                            data-bs-target={"#collapseOne_" + order.order_id}
                            // aria-expanded="false"
                            aria-controls={"collapseOne_" + order.order_id}
                            onClick={() =>
                              isPaid(order) &&
                              handleToggleCollapse(order.order_id)
                            }
                            aria-expanded={
                              isPaid(order) && openCollapseId === order.order_id
                                ? "true"
                                : "false"
                            }
                          >
                            <ul>
                              <li>
                                <img
                                  src={`${process.env.REACT_APP_BASE_URL}/${order?.image}`}
                                  alt="histhomeimg"
                                  onError={handleError}
                                />{" "}
                                <div className="detail-dropdown">
                                  <h6>
                                    {order.house.name} : ${order?.house?.price}
                                    /per month{" "}
                                  </h6>
                                  <span>
                                    Security Amount : $
                                    {order.house.security_price}
                                  </span>
                                  <span>Total Amount : ${order.total}</span>
                                </div>
                              </li>
                              <li>
                                <p>
                                  Date :
                                  {new Date(
                                    order.created_at
                                  ).toLocaleDateString()}
                                </p>
                                <p>Order ID : {order.order_id}</p>
                                <p
                                  style={{
                                    color:
                                      order.payment_status === "succeeded"
                                        ? "green"
                                        : order.payment_status === "pending"
                                        ? "yellow"
                                        : "red",
                                  }}
                                >
                                  {" "}
                                  Payment Status :{" "}
                                  {order.payment_status
                                    ? order.payment_status
                                    : "Unpaid"}
                                </p>

                                <p>{"View More"}</p>
                              </li>
                            </ul>
                          </button>
                        </h2>
                        <div
                          id={"collapseOne_" + order.order_id}
                          className={
                            "accordion-collapse collapse" +
                            (openCollapseId === order.order_id ? " show" : "")
                          }
                          aria-labelledby={"headingOne_" + order.order_id}
                          data-bs-parent="#accordionExample"
                        >
                          {/* {isPaid(order) ? ( */}
                          <div className="accordion-body">
                            <div className="hist_main">
                              <div className="hist_img">
                                <img
                                  src={`${process.env.REACT_APP_BASE_URL}/${order?.image}`}
                                  alt="histhomeimg"
                                  onError={handleError}
                                />
                              </div>
                              <div className="hist_cont">
                                <div className="history-inner-content">
                                  <h4>
                                    {order?.house?.name}(
                                    {order?.house?.house_facility})
                                  </h4>
                                  <p>
                                    {/* 42 Broadway, New York, NY 10004, USA , 42
                                    Broadway,
                                    <br /> New York, NY 10004, USA */}
                                    {order?.house?.full_address}
                                  </p>
                                  <div className="month_cont">
                                    <h2>
                                      Starting Month :{" "}
                                      {new Date(
                                        order?.house?.lease_start_date
                                      ).toLocaleDateString()}
                                    </h2>
                                    <h2>
                                      End Month :{" "}
                                      {new Date(
                                        order?.house?.lease_end_date
                                      ).toLocaleDateString()}
                                    </h2>
                                  </div>
                                  <p>Lease Period :{order.house.leaseTime}</p>
                                  <p>
                                    Tenant :
                                    <spam
                                      onClick={() =>
                                        handleClickOnName(
                                          "tenant",
                                          order.tenant.id
                                        )
                                      }
                                    >
                                      {" "}
                                      {`${order.tenant.first_name} ${order.tenant.last_name} `}
                                    </spam>
                                  </p>
                                </div>
                                <div className="history-inner-content">
                                  <div className="payment_cont">
                                    <h4>
                                      <img
                                        src={img_checkicon}
                                        alt="checkicon"
                                      />{" "}
                                      Payment Status :{" "}
                                      {order?.payment_status
                                        ? "Paid"
                                        : "Unpaid"}
                                    </h4>
                                    {order?.payment_status && (
                                      <h4>
                                        <img src={img_clock} alt="clock" /> Time
                                        :{" "}
                                        {`${new Date(
                                          order?.payment[0]?.created_at
                                        )
                                          .getHours()
                                          .toString()
                                          .padStart(2, "0")}:${new Date(
                                          order?.payment[0]?.created_at
                                        )
                                          .getMinutes()
                                          .toString()
                                          .padStart(2, "0")}`}
                                      </h4>
                                    )}
                                  </div>
                                  {order?.payment_status && (
                                    <div className="payment_cont pay_status">
                                      <h4>
                                        <img src={img_Date} alt="checkicon" />{" "}
                                        {new Date(
                                          order?.payment[0]?.created_at
                                        ).toLocaleDateString()}
                                      </h4>
                                      <h4>
                                        <img src={img_invoice} alt="invoice" />{" "}
                                        {`$${
                                          +order?.payment[0]?.amount / 100
                                        }/${
                                          order.payment[0]?.subscription_type
                                        }`}
                                      </h4>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            {order?.cleaning.length > 0 && (
                              <div className="hist_main cleaning">
                                <div className="hist_img">
                                  <img src={img_cpclean} alt="cpbrook" />
                                </div>
                                <div className="hist_cont">
                                  <div className="history-inner-content">
                                    <h4>Cleaning Plan</h4>
                                    <p>
                                      Cleaning Company:{" "}
                                      <spam
                                        onClick={() =>
                                          handleClickOnName(
                                            "cleaning_company",
                                            order.CleaningCompany.id
                                          )
                                        }
                                      >
                                        {" "}
                                        {order.CleaningCompany.name}
                                      </spam>
                                    </p>

                                    {order?.cleaning.length > 0 &&
                                      order.cleaning.map((cleaning, i) => (
                                        <div key={i} className="cleaning-plan">
                                          <h4>Plan Name: {cleaning.name}</h4>
                                          <p>
                                            <strong>Frequency: </strong>
                                            {cleaning.frequency}
                                          </p>
                                          <p>
                                            <strong>
                                              Price per Frequency:{" $"}
                                            </strong>
                                            {cleaning.price}
                                          </p>
                                        </div>
                                      ))}

                                    {/* <p>
                                    Next Cleaning Timing :
                                    <span className="basic_clean_inner">
                                      {" "}
                                      02/06/2023
                                    </span>
                                  </p> */}
                                    <p>
                                      Total Cleaning Cost :
                                      <span className="basic_clean_inner">
                                        {" "}
                                        $
                                        {order?.cleaning.length > 0 &&
                                          order.cleaning.reduce(
                                            (acc, cleaning) =>
                                              acc +
                                              parseFloat(cleaning.price) *
                                                parseFloat(cleaning.frequency),
                                            0
                                          )}
                                      </span>
                                    </p>
                                    {/* <div className="month_cont">
                                    <h2>Starting Month : 23/05/2023</h2>
                                    <h2>End Month : 23/11/2023</h2>
                                  </div> */}
                                  </div>
                                </div>
                              </div>
                            )}

                            {order.furniture.length > 0 && (
                              <div className="hist_main cleaning furniture">
                                <div className="hist_img">
                                  <img src={img_cpdelux} alt="cpbrook" />
                                </div>
                                <div className="hist_cont">
                                  <div className="history-inner-content">
                                    <h4>{order?.furniture[0]?.name}</h4>
                                    <p>
                                      <strong>
                                        Total Item of Furniture :{" "}
                                      </strong>
                                      <span className="basic_clean_inner">
                                        {order?.furniture.length}
                                      </span>
                                    </p>
                                    <p>
                                      <strong>
                                        furniture provider company Name :
                                      </strong>
                                      <span
                                        className="basic_clean_inner"
                                        onClick={() =>
                                          handleClickOnName(
                                            "furniture_company",
                                            order?.furniture[0]?.fur_comapany_id
                                          )
                                        }
                                      >
                                        {" "}
                                        {order?.furniture[0]?.comapany_name}
                                      </span>
                                    </p>
                                    <p>
                                      <strong>furniture cost :</strong>
                                      <span className="basic_clean_inner">
                                        {" $"}
                                        {order?.furniture.length > 0 &&
                                          order.furniture.reduce(
                                            (acc, furniture) =>
                                              acc +
                                              parseFloat(furniture?.price) *
                                                parseFloat(furniture?.quantity),
                                            0
                                          )}
                                        {"/per month"}
                                      </span>
                                    </p>
                                    <div className="month_cont">
                                      <p>
                                        <strong>
                                          furniture delivery date :{" "}
                                        </strong>
                                        {order.furn_delivery_date
                                          ? new Date(
                                              order.furn_delivery_date
                                            ).toLocaleDateString()
                                          : "not Delivered"}
                                      </p>

                                      {/* <h2>End Month : 23/11/2023</h2> */}
                                    </div>
                                  </div>
                                  <div className="delux_furnit_item_inner">
                                    {order?.furniture.length > 0 &&
                                      order?.furniture.map((furniture) => {
                                        return (
                                          <div className="delux_item">
                                            <div className="book_item_img">
                                              <img
                                                src={`${process.env.REACT_APP_BASE_URL}${furniture?.image}`}
                                                alt=""
                                              />
                                            </div>
                                            <div className="zunkel_cont">
                                              <h4
                                                onClick={() =>
                                                  navigate(
                                                    `/user/furniture_company/furniture`,
                                                    {
                                                      state: {
                                                        furId: furniture?.furId,
                                                      },
                                                    }
                                                  )
                                                }
                                              >
                                                {furniture?.fur_name}
                                              </h4>
                                              <p>
                                                <span className="br_item">
                                                  {furniture?.quantity} item
                                                </span>{" "}
                                                <span className="br_left">
                                                  <span
                                                    className="color-dot"
                                                    style={{
                                                      backgroundColor:
                                                        furniture?.color,
                                                    }}
                                                  ></span>
                                                  {furniture?.color && (
                                                    <span className="color-name">
                                                      {GetColorName(
                                                        furniture?.color
                                                      )}
                                                    </span>
                                                  )}
                                                </span>
                                              </p>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          {/* // ) : (
                          //   <div className="accordion-body">
                          //     <div>user cannot complete this order </div>
                          //   </div>
                          // )} */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Data not found</p>
      )}
    </>
  );
};

export default OrderHistory;
